<template>
	<v-card class="hero-card rounded-lg" :style="background">
		<h1>
			<slot> CARRERAS KINESIA </slot>
		</h1>
	</v-card>
</template>

<script>
	export default {
		props: {
			color1: {
				type: String,
				default: "rgba(32,32,39,0.65)",
			},
			color2: {
				type: String,
				default: "rgba(32,32,39,0.65)",
			},
			image: Boolean,
		},
		computed: {
			background() {
				if (this.image) {
					return {
						background: `linear-gradient(90deg, ${this.color1} 0%, ${this.color2} 100%)`,
						"background-position": " 50% 90%",
						"background-size": "cover",
					};
				} else {
					return {
						background: `linear-gradient(90deg, ${this.color1} 0%, ${this.color2} 100%)`,
					};
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import "../../../scss/_mixins.scss";

	.hero-card {
		display: flex;
		min-height: 160px;
		align-items: center;
		padding: 1.5em;
		width: 100%;

		h1 {
			font-size: 2.5em;
			color: #fff;
			text-align: left;

			@include desktop() {
				font-size: 4em;
			}
		}
	}
</style>
